import { Building2, Calendar, ExternalLink, MapPin } from "lucide-react";
import { Button } from "@openai/apps-sdk-ui/components/Button";
import { Image } from "@openai/apps-sdk-ui/components/Image";
import { formatDate, toEmlakjetUrl, openExternal } from "../utils";

/**
 * Single project card component
 */
export function ProjectCard({ project, isDark }) {
  const href = toEmlakjetUrl(project?.url);
  const deliveryLabel = formatDate(project?.deliveryDate);

  return (
    <div
      className={`rounded-2xl border shadow-sm overflow-hidden ${
        isDark ? "border-white/10 bg-zinc-800" : "border-black/10 bg-white"
      }`}
    >
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 p-3 sm:p-4">
        {/* Project Image */}
        <div
          className={`h-32 sm:h-20 w-full sm:w-28 rounded-xl overflow-hidden flex-shrink-0 ${
            isDark ? "bg-white/5" : "bg-black/5"
          }`}
        >
          {project?.image ? (
            <Image
              src={project.image}
              alt={project?.name ? String(project.name) : "Project image"}
              className="h-full w-full object-cover"
            />
          ) : null}
        </div>

        {/* Project Info */}
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold line-clamp-2">
            {project?.name ?? "Proje"}
          </div>

          {/* Metadata */}
          <div
            className={`mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs ${
              isDark ? "text-white/60" : "text-black/60"
            }`}
          >
            {project?.location ? (
              <span className="inline-flex items-center gap-1 min-w-0">
                <MapPin className="h-3.5 w-3.5" strokeWidth={1.5} />
                <span className="truncate">{String(project.location)}</span>
              </span>
            ) : null}
            {project?.companyName ? (
              <span className="inline-flex items-center gap-1 min-w-0">
                <Building2 className="h-3.5 w-3.5" strokeWidth={1.5} />
                <span className="truncate">{String(project.companyName)}</span>
              </span>
            ) : null}
            {deliveryLabel ? (
              <span className="inline-flex items-center gap-1">
                <Calendar className="h-3.5 w-3.5" strokeWidth={1.5} />
                Teslim: {deliveryLabel}
              </span>
            ) : null}
          </div>

          {/* Price and Action */}
          <div className="mt-2 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
            <div className="text-sm font-semibold">
              {project?.priceSummary ?? "Fiyat bilgisi yok"}
            </div>
            <div className="flex items-center gap-2 sm:ml-auto">
              <Button
                size="sm"
                variant="outline"
                onClick={() => openExternal(href)}
                disabled={!href}
              >
                <ExternalLink className="h-4 w-4" strokeWidth={1.5} />
                <span className="ml-2 hidden sm:inline">Projeyi aç</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectCard;
